<ng-container [formGroup]="parent">
  <ng-container formGroupName="lines">
    <h3 class="mb-2">Line detail</h3>
    <div class="row">
      <div class="col mb-2">
        <div class="form-group has-float-label">
          <label class="form-label">Vendor SKU</label>
          <input
            pInputText
            jniAutoCompleteBlocker
            type="text"
            class="form-control"
            placeholder=""
            formControlName="externalItemNumberD365"
            (focusout)="applyVendorSkuLengthValidation($event)" />
        </div>
      </div>
      <div class="col mb-2">
        <div class="form-group has-float-label">
          <label class="form-label"
            >Category<span class="madatory-field">*</span></label
          >
          <p-select
            id="currency"
            formControlName="itemNumberD365"
            [ngClass]="{ 'has-error': formErrors['itemNumberD365'] }"
            (blur)="logValidationErrors()"
            [options]="releasedProductsList"
            optionValue="itemNumberD365"
            optionLabel="itemNumberD365"
            [filter]="true"
            [showClear]="true">
          </p-select>

          <span class="error-msg" *ngIf="formErrors['itemNumberD365']">
            {{ formErrors["itemNumberD365"] }}
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-4 mb-2">
        <div class="form-group has-float-label">
          <label class="form-label"
            >Quantity <span class="madatory-field">*</span></label
          >
          <input
            pInputText
            jniAutoCompleteBlocker
            type="text"
            class="form-control"
            formControlName="orderedPurchaseQuantityD365"
            (focusout)="onQuantityChange($event)"
            [ngClass]="{
              'has-error': formErrors['orderedPurchaseQuantityD365'],
            }"
            (blur)="logValidationErrors()" />

          <span
            class="error-msg"
            *ngIf="formErrors['orderedPurchaseQuantityD365']">
            {{ formErrors["orderedPurchaseQuantityD365"] }}
          </span>
        </div>
      </div>
      <div class="col-2 mb-2 d-flex align-items-center justify-content-center">
        <p-checkbox
          formControlName="isnetInForeignCurrencyStatus"
          [binary]="true"
          (onChange)="onCurrencyEnable($event)" />
      </div>
      <div class="col-4 mb-2 d-flex align-items-center">
        <div class="form-group has-float-label flex-grow-1">
          <label class="form-label">Net in Foreign Currency</label>
          <p-select
            id="currency"
            formControlName="currencyCodeD365"
            (onChange)="onCurrencyConversion()"
            [options]="currencyList"
            optionValue="isoCurrencyCodeD365"
            optionLabel="isoCurrencyCodeD365"
            [filter]="true"
            [showClear]="true">
          </p-select>
        </div>
      </div>
      <div class="col-2 mb-2">
        <div class="form-group switcher">
          <label class="form-label d-block l-height mt-2 mb-1">Trackable</label>
          <div
            class="form-check form-switch d-flex align-items-center m-0 gap-2">
            <p-toggleswitch
              id="trackable"
              name="trackable"
              formControlName="isTrackable" />

            <label class="form-check-label" for="trackable">
              {{ this.parent.get(["lines", "isTrackable"])?.value }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col mb-3">
        <div class="row">
          <div class="col has-icon">
            <div class="form-group has-float-label">
              <label class="form-label">Sell</label>
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                [value]="
                  sellRateValueWithIcon
                    | currency: sellIsoCurrencyCode : 'symbol' : '0.3-3'
                "
                (focusout)="onSellConversion($event)" />
            </div>
          </div>
          <div class="col">
            <div class="form-group has-float-label" *ngIf="sellCurrencyStatus">
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                [value]="
                  sellConvertToUsd | currency: 'USD' : 'symbol' : '0.3-3'
                "
                disabled />
            </div>
          </div>
        </div>
      </div>
      <div class="col mb-3">
        <div class="row d-flex align-items-end">
          <div class="col has-icon">
            <div class="form-group has-float-label">
              <label class="form-label">NET</label>
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                [value]="
                  netValueWithIcon
                    | currency: isoCurrencyCode : 'symbol' : '0.4-4'
                "
                (focusout)="onNetConversion($event)"
                [disabled]="netFieldStatus" />
            </div>
          </div>
          <div class="col">
            <div class="form-group has-float-label" *ngIf="showForeignCurrency">
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                [value]="netConvertToUsd | currency: 'USD' : 'symbol' : '0.4-4'"
                disabled />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col mb-3">
        <div class="row">
          <div class="col has-icon">
            <div class="form-group has-float-label">
              <label class="form-label">Sell Total</label>
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                [value]="
                  sellTotalPrice
                    | currency: sellIsoCurrencyCode : 'symbol' : '1.2-2'
                "
                disabled />
            </div>
          </div>
          <div class="col">
            <div class="form-group has-float-label" *ngIf="sellCurrencyStatus">
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                [value]="
                  sellTotalPriceConverted | currency: 'USD' : 'symbol' : '1.2-2'
                "
                disabled />
            </div>
          </div>
        </div>
      </div>
      <div class="col mb-3">
        <div class="row d-flex align-items-end">
          <div class="col has-icon">
            <div class="form-group has-float-label">
              <label class="form-label">Net Total</label>
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                [value]="
                  netTotalPrice | currency: isoCurrencyCode : 'symbol' : '1.2-2'
                "
                disabled />
            </div>
          </div>
          <div class="col">
            <div class="form-group has-float-label" *ngIf="showForeignCurrency">
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                [value]="
                  netTotalPriceConverted | currency: 'USD' : 'symbol' : '1.2-2'
                "
                disabled />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group has-float-label">
          <label class="form-label">Commission</label>
          <input
            pInputText
            jniAutoCompleteBlocker
            type="text"
            class="form-control"
            [value]="commission | currency: 'USD'"
            [disabled]="true" />
        </div>
      </div>
      <div class="col">
        <div class="form-group has-float-label">
          <label class="form-label">Gross Profit %</label>
          <input
            pInputText
            jniAutoCompleteBlocker
            type="text"
            class="form-control"
            [value]="grossProfit"
            disabled />
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
